module.exports = __webpack_public_path__ + "img/121.b64720ff.png";